import {GetAllContactSettingUrl, UpdateContactCallingNumberUrl,
      UpdateDispatcherCallingNumberUrl, UpdateSupportCallingNumberUrl , 
      UpdateSupportEmailAddressUrl,UpdateEnableDirectCallingUrl } from '../../Comman/apiEndPoints';
import varAxios from "../../Comman/axios";

export const Fetch_All_Contact_Settings_Data = "Fetch_All_Contact_Settings_Data";
export const Update_Contact_Setting_Success = "Update_Contact_Setting_Success";
export const Clear_State = "Clear_State";

export function getAllContactSettings() {
    return(dispatch) =>{
       return varAxios.get(GetAllContactSettingUrl)
       .then(response => {
          dispatch(
            fetchAllContactSettingsData({
                errorCode : response.data.errorCode,
                statusCode : response.data.statusCode,
                allSetting : response.data.GlobalSettings
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllContactSettingsData({errorCode, statusCode, allSetting}) {
    return {
      type : Fetch_All_Contact_Settings_Data,
      errorCode,
      statusCode,
      allSetting
    }
}
export function updateDataSuccess(errorCode,statusCode,message,updatedValue) {
  return {
    type : Update_Contact_Setting_Success,
    errorCode,
    statusCode,
    message,
    updatedValue
  }
}
export function updateContactCallingNumber(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
      return varAxios.post(UpdateContactCallingNumberUrl, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                updateDataSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function UpdateDispatcherCallingNumber(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
      return varAxios.post(UpdateDispatcherCallingNumberUrl, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                updateDataSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function UpdateSupportCallingNumber(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
      return varAxios.post(UpdateSupportCallingNumberUrl, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                updateDataSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function UpdateSupportEmailAddress(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
      return varAxios.post(UpdateSupportEmailAddressUrl, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                updateDataSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function clearStore() {
  return (dispatch) => {
    dispatch(
      clear(false)
    );
  }
}
export function clear(isLoading) {
  return {
    type : Clear_State,
    isLoading
  }
}
export function updateEnableDirectCalling(value) {
  let data = {
    SettingValue : value
  }
  return (dispatch) => {
      return varAxios.post(UpdateEnableDirectCallingUrl, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
            if(response.data.statusCode == 200){
              dispatch(
                updateDataSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.Value)
              );
            }
          })
          .catch((error) => {
              console.log(error)
          })
  }
}